<template>
    <div class="container">
        <div class="col-md-12 mt-3">
            <h2> {{ labels.title }} </h2>
        </div>
        <div class="row col-md-12 mt-4 form-group">
            <div class="col-md-3">
                <h5>{{ labels.contrato }}</h5>
                <div class="checkbox-scroll">
                    <div class="checkbox-item form-control">
                        <label>
                            <input
                                type="checkbox"
                                v-model="contratosSelAll"
                                @click="selAllChkContrato"
                            />
                        </label>
                        {{ labels.selectTodos }}
                    </div>
                    <div
                        class="checkbox-item form-control"
                        v-for="contrato in lstContratos"
                        :key="contrato.id"
                    >
                        <label>
                            <input
                                type="checkbox"
                                :value="contrato.nro_contrato"
                                v-model="contratosSel"
                                @click="selChkContrato"
                            />
                        </label>
                        {{ contrato.nro_contrato }}
                    </div>
                </div>
            </div>
            <div class="col-md-9">
                <h5>{{ labels.arrendador }}</h5>
                <div class="checkbox-scroll">
                    <div class="checkbox-item form-control">
                        <label>
                            <input
                                type="checkbox"
                                v-model="arrendadorSelAll"
                                @click="selAllChkArrendador"
                            />
                        </label>
                        {{ labels.selectTodos }}
                    </div>
                    <div
                        class="checkbox-item form-control"
                        v-for="arrendador in lstArrendador"
                        :key="arrendador.id"
                    >
                        <label>
                            <input
                                type="checkbox"
                                :value="arrendador.identificacion"
                                v-model="arrendadorSel"
                                @click="selChkArrendador"
                            />
                        </label>
                        {{ arrendador.nombre }}
                    </div>
                </div>
            </div>
        </div>
        <div class="col-md-12 mt-5">
            <b-button type="button" id="create-btn" @click="consultaReporte">{{ labels.consultar }}</b-button>
        </div>
        <div class="col-md-12 mt-5">
            <h3>{{ tituloReporte }}</h3>
            <div v-if="btnGenExcel" class="row col-md-12 d-flex justify-content-end">
                <md-button style="background-color: #2e507a; width: 40px; height: 40px;" class="md-fab md-primary" @click="generaReporteActivos()">
                    <md-icon>
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 640"><path fill="#ffffff" d="M192 112L304 112L304 200C304 239.8 336.2 272 376 272L464 272L464 512C464 520.8 456.8 528 448 528L192 528C183.2 528 176 520.8 176 512L176 128C176 119.2 183.2 112 192 112zM352 131.9L444.1 224L376 224C362.7 224 352 213.3 352 200L352 131.9zM192 64C156.7 64 128 92.7 128 128L128 512C128 547.3 156.7 576 192 576L448 576C483.3 576 512 547.3 512 512L512 250.5C512 233.5 505.3 217.2 493.3 205.2L370.7 82.7C358.7 70.7 342.5 64 325.5 64L192 64zM291.2 329.6C283.2 319 268.2 316.8 257.6 324.8C247 332.8 244.8 347.8 252.8 358.4L290 408L252.8 457.6C244.8 468.2 247 483.2 257.6 491.2C268.2 499.2 283.2 497 291.2 486.4L320 448L348.8 486.4C356.8 497 371.8 499.2 382.4 491.2C393 483.2 395.2 468.2 387.2 457.6L350 408L387.2 358.4C395.2 347.8 393 332.8 382.4 324.8C371.8 316.8 356.8 319 348.8 329.6L320 368L291.2 329.6z"/></svg>
                    </md-icon>
                </md-button>
            </div>
            <div class="row col-md-12 justify-content-center" v-if="lstActContrato != 0">
                <b-table
                    :items="lstActContrato"
                    :fields="fields"
                    hover
                    bordered
                    responsive
                    sticky-header="500px"
                    small
                    class="tblEstandar"
                    head-variant="custom-blue"
                    :per-page="perPage"
                    :current-page="currentPage"
                    v-if="tituloReporte == 'Activos por Contrato'"
                >
                    <template #cell(valor_compra)="data">
                        <div class="text-right">{{ formatNumber(data.item.valor_compra) }}</div>
                    </template>
                    <template #cell(valor_salvamento)="data">
                        <div class="text-right">{{ formatNumber(data.item.valor_salvamento) }}</div>
                    </template>
                </b-table>
                <b-table
                    :items="lstActContrato"
                    :fields="field"
                    hover
                    bordered
                    responsive
                    sticky-header="500px"
                    small
                    class="tblEstandar"
                    head-variant="custom-blue"
                    :per-page="perPage"
                    :current-page="currentPage"
                    v-else
                >
                    <template #cell(valor_compra)="data">
                        <div class="text-right">{{ formatNumber(data.item.valor_compra) }}</div>
                    </template>
                    <template #cell(valor_salvamento)="data">
                        <div class="text-right">{{ formatNumber(data.item.valor_salvamento) }}</div>
                    </template>
                </b-table>
                <div class="row col-md-12 mt-1">
                    <div class="col-md-10 d-flex justify-content-center">
                        <b-pagination
                        v-model="currentPage"
                        :total-rows="lstActContrato.length"
                        :per-page="perPage"
                        :align="center"
                        size="md"
                        class="custom-pagination"
                        ></b-pagination>
                    </div>
                    <div class="col-md-2 d-flex justify-content-end">
                        <label class="mr-2 mb-0">Filas por página:</label>
                        <b-form-select
                            v-model="perPage"
                            :options="[5, 10, 20, 50, 100, 500]"
                            size="sm"
                            style="width: 80px;"
                        ></b-form-select>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Contrato from '../../services/Contrato';
import Tercero from '../../services/Tercero';
import Reportes from '../../services/Reportes';
import * as XLSX from "exceljs";

export default {
    name : 'ActivosPorContrato',
    data : () => ({
        lstContratos : [],
        contratosSel : [],
        lstArrendador : [],
        arrendadorSel : [],
        lstActContrato : [],
        btnGenExcel : false,
        contratosSelAll : false,
        arrendadorSelAll : false,
        tituloReporte : '',
        perPage: 500,
        currentPage: 1,
        fields : [
            { key: 'nro_contrato', label: 'Contrato', sortable: false },
            { key: 'arrendador', label: 'Arrendador', sortable: false },
            { key: 'tipo_activo', label: 'Tipo activo', sortable: false },
            { key: 'descripcion', label: 'Descripción', sortable: false },
            { key: 'valor_compra', label: 'Valor compra', sortable: false },
            { key: 'valor_salvamento', label: 'Valor salvamento', sortable: false },
            { key: 'fecha_compra', label: 'Fecha compra', sortable: false },
        ],
        field : [
            { key: 'arrendador', label: 'Arrendador', sortable: false },
            { key: 'nro_contrato', label: 'Contrato', sortable: false },
            { key: 'tipo_activo', label: 'Tipo activo', sortable: false },
            { key: 'descripcion', label: 'Descripción', sortable: false },
            { key: 'valor_compra', label: 'Valor compra', sortable: false },
            { key: 'valor_salvamento', label: 'Valor salvamento', sortable: false },
            { key: 'fecha_compra', label: 'Fecha compra', sortable: false },
        ]
    }),
    computed:{
        labels(){
            if(this.$store.state._language == "es-ES"){
                return {
                    title : 'Reporte activos',
                    consultar : 'Consultar',
                    contrato : 'Contrato:',
                    arrendador : 'Arrendador:',
                    arrendado : 'Arrendador',
                    fecha : 'Fecha:',
                    nro_contrato : 'Contrato',
                    tipo_activo : 'Tipo activo',
                    descripcion : 'Descripción',
                    valor_compra : 'Valor compra',
                    valor_salvamento : 'Valor salvamento',
                    fecha_compra : 'Fecha compra',
                    selectTodos : 'Seleccionar todos'
                }
            }else{
                return {
                    title : 'Asset report',
                    consultar : 'Consult',
                    contrato : 'Contract:',
                    arrendador : 'Lessor:',
                    arrendado : 'Lessor',
                    fecha : 'Date:',
                    nro_contrato : 'Contract',
                    tipo_activo : 'Active type',
                    descripcion : 'Description',
                    valor_compra : 'Purchase value',
                    valor_salvamento : 'Valor salvamento',
                    fecha_compra : 'Purchase date',
                    selectTodos : 'Select all'
                }
            }
        }
    },
    methods:{
        consultaReporte(){
            // console.log(this.contratosSel);
            // console.log(this.arrendadorSel);

            if(this.contratosSel.length != 0){

                this.tituloReporte = 'Activos por Contrato'

                Reportes.getActivosPorContract(this.contratosSel)
                .then((res) => {
                    // console.log(res.data.result);
                    this.lstActContrato = res.data.result

                    if(this.lstActContrato.length != 0){
                        this.btnGenExcel = true
                    }else{
                        this.btnGenExcel = false
                    }
                })
                .catch((err) => console.log(err))

            }else{

                this.tituloReporte = 'Activos por Arrendador'

                Reportes.getActivosPorArrendad(this.arrendadorSel)
                .then((res) => {
                    // console.log(res.data.result);
                    this.lstActContrato = res.data.result

                    if(this.lstActContrato.length != 0){
                        this.btnGenExcel = true
                    }else{
                        this.btnGenExcel = false
                    }
                })
                .catch((err) => console.log(err))
            }
        },
        selChkContrato(){
            this.arrendadorSel = [] // limpio los check de la otra lista
            this.lstActContrato = [] // limpio la tabla que se arma cuando se selecciona un check si a esta se le habia dado cunsultar
            this.btnGenExcel = false
            this.tituloReporte = ''
        },
        selAllChkContrato(){
            if (!this.contratosSelAll) {
                this.contratosSel = this.lstContratos.map(c => c.nro_contrato);
            } else {
                this.contratosSel = [];
            }
        },
        selChkArrendador(){
            this.contratosSel = [] // limpio los check de la otra lista
            this.lstActContrato = [] // limpio la tabla que se arma cuando se selecciona un check si a esta se le habia dado cunsultar
            this.contratoSelAll = false
            this.btnGenExcel = false
            this.contratosSelAll = false
            this.tituloReporte = ''
        },
        selAllChkArrendador(){
            if (!this.arrendadorSelAll) {
                this.arrendadorSel = this.lstArrendador.map(a => a.identificacion);
            } else {
                this.arrendadorSel = [];
            }
        },
        async generaReporteActivos(){
            // console.log('generaReporteActivos');

            const {Workbook} = XLSX
            const workbook = new Workbook()
            const worksheet = workbook.addWorksheet("Lista de activos")

            const titulo = ['Lista de activos']
            worksheet.addRow(titulo)
            worksheet.mergeCells('A1:F1')
            worksheet.getCell('A1').font = { bold : true, size : 12};
            worksheet.getCell('A1').alignment = { horizontal : 'center'};

            let tituloCelda = []

            if(this.tituloReporte == 'Activos por Arrendador'){

                tituloCelda = [
                    'Arrendador',
                    'Contrato',
                    'Tipo activo',
                    'Descripción',
                    'Valor compra',
                    'Valor salvamento',
                    'Fecha compra'
                ]

            }else{

                tituloCelda = [
                    'Contrato',
                    'Arrendador',
                    'Tipo activo',
                    'Descripción',
                    'Valor compra',
                    'Valor salvamento',
                    'Fecha compra'
                ]
            }
            worksheet.addRow(tituloCelda)
            for	(let fila = 1;fila<=2;fila++) {
                worksheet.getRow(fila).font = {
                    name: "Arial Black",
                    family: 2,
                    size: 11,
                    bold: true
                }
            }

            this.lstActContrato.map((e) => {
                worksheet.addRow([
                    this.tituloReporte == 'Activos por Arrendador' ? e.arrendador : e.nro_contrato,
                    this.tituloReporte == 'Activos por Arrendador' ? e.nro_contrato : e.arrendador,
                    e.tipo_activo,
                    e.descripcion,
                    this.formatNumber(e.valor_compra),
                    this.formatNumber(e.valor_salvamento),
                    e.fecha_compra
                ])
            })

            //Poner borde
            const border = {
                top : {style : 'thin'},
                left : {style : 'thin'},
                bottom : {style : 'thin'},
                right : {style : 'thin'},
            }

            for( let row = 1; row <= worksheet.rowCount; row++){
                for( let col = 1; col <= worksheet.columnCount; col++){
                    worksheet.getCell(row, col).border = border;
                }
            }
            //------

            const file = await workbook.xlsx.writeBuffer()
            const downloadLink = document.createElement("a")
            downloadLink.download = "Lista de activos.xlsx"
            downloadLink.href = window.URL.createObjectURL(
                new Blob([file], {
                type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                })
            )

            downloadLink.style.display = "none";

            document.body.appendChild(downloadLink);
            downloadLink.click();

            downloadLink.remove();
        },
        formatNumber(valor){
            return Intl.NumberFormat('es-CO',{ maximumFractionDigits: 3, minimumFractionDigits: 0}).format(valor)
        }
    },
    mounted(){
        Contrato.getAllContratos()
        .then((res) => {
            this.lstContratos = res.data.listContratos
        })
        .catch((err) => console.log(err))

        Tercero.getAllTercero()
        .then((res) => {
            this.lstArrendador = res.data.listTercero
        })
        .catch((err) => console.log(err))
    }
}
</script>

<style scoped>
.checkbox-scroll {
  max-height: 200px; /* altura visible */
  overflow-y: auto;  /* scroll vertical si hay más */
  border: 1px solid #ccc;
  padding: 10px;
  border-radius: 5px;
}

.checkbox-item {
  margin-bottom: 5px;
  display: flex;
  align-items: center;
  align-self: center;
  justify-content: flex-start; /* Alinea a la izquierda */
  gap: 8px; /* Espacio entre el checkbox y el texto */
}

input[type="checkbox"] {
  vertical-align: middle;
}
</style>